<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte de Transferencias</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <span class="title">Filtros</span>
        <v-divider></v-divider>
        <v-row dense>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Transferencias de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.canalVentaId"
              :items="canalesVenta"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Originadas en"
              placeholder="Seleccione un Canal de Venta"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <app-selector-periodos
              v-on:update-periodo="filtro.periodo = $event"
            ></app-selector-periodos>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="2">
            <v-autocomplete
              v-model="filtro.formatoId"
              :items="formatos"
              item-text="descripcion"
              item-value="formatoId"
              label="Formato"
              no-data-text="Seleccione una Empresa para ver los Formatos"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row dense> </v-row>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn> -->
        <v-spacer></v-spacer>
        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      filtro: {
        empresaId: 0,
        canalVentaId: 0,
        periodo: { id: 1 },
        formatoId: 0,
      },
      empresas: [],
      canalesVenta: [],
      formatos: [],  
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadCanalesVenta();
  },

    watch: {

    "filtro.empresaId": function () {
      this.loadFormatosEmpresa();
    },
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id
        );

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?usuarioId=" + this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadFormatosEmpresa() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/formatostransferencia?empresaId=" +
            this.filtro.empresaId
        );
        this.formatos = result.list;
        console.log(this.formatos)
        console.log((this.formatoId))
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    validar() {
      
      if (this.filtro.empresaId === 0) {
        this.alertWarning("Debe seleccionar una Empresa.");
        return false;
      }

      if (this.filtro.formatoId === 0) {
        this.alertWarning("Debe seleccionar un Formato.");
        return false;
      }

      return true;
    },
    async procesarReporte() {
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        let params = [];
        console.log(this.filtro)
        params.push({
          "EmpresaId": this.filtro.empresaId,
          "SucursalId": this.filtro.canalVentaId,
          "FormatoId": this.filtro.formatoId,
          "FechaTransferenciaDesde": this.filtro.periodo.desde,
          "FechaTransferenciaHasta": this.filtro.periodo.hasta,
        });

        this.setReporteActivo({
          reporte: "Reporte Transferencias.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>